import { render } from "./soal_text.vue?vue&type=template&id=5074b4ee&scoped=true"
import script from "./soal_text.vue?vue&type=script&lang=js"
export * from "./soal_text.vue?vue&type=script&lang=js"

import "./soal_text.vue?vue&type=style&index=0&id=5074b4ee&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5074b4ee"]])

export default __exports__